import moment from "moment";
import "moment/locale/es";
import {
  Button, ButtonGroup, makeStyles, Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  DialogContentText,
  DialogActions
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import React, { memo, useEffect } from "react";
import { fetchEspecialidades } from "../../../actions/especialidades";
import { useSelector, useDispatch } from "react-redux";
import {
  getCartillaPrestadores,
  getRubrosEfector,
  getZonasEfector,
  getCentrosMedicos,
  getCartilla,
  getPlanes,
  getRankingsCartilla,
  SubirArchivoExcel,
  DescargarPlantillaExcel,
  contratacionesPrestadorSave,
  contratacionesPrestadoresDeleteAll,
} from "../../../actions/contrataciones/contratacionesCartilla";
import { MENU_CONTRATACIONES, SUBTIPO_EFECTORES } from "../../../utils/constants";
import { PrestadoresTable } from "./PrestadoresTable";
import { PrestadoresForm } from "./PrestadoresForm";
import { fetchLocalidades } from "../../../actions/cbos/localidades";
import { fetchProvincias } from "../../../actions/cbos/provincias";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData"
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    marginBottom: 15,
  },
}));

export const CartillaContrataciones = memo((props) => {
  moment.locale("es");

  const dispatch = useDispatch();
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalDeleteAll, setOpenModalDeleteAll] = React.useState(false);

  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const disabled = props.menu === MENU_CONTRATACIONES.CONSULTA;

  const {
    prestadores,
    rubros,
    zonas,
    centrosMedicos,
    rankingsCartilla,
    cartilla,
    planes,
  } = useSelector((state) => state.contratacionesCartilla);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { items: localidades } = useSelector((state) => state.localidades);
  const { items: provincias } = useSelector((state) => state.provincias);
  const idEfectorFact = props.idEfectorFacturacion;

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleSearch = (textoBuscado) => {
    dispatch(getCartillaPrestadores(idEfectorFact, textoBuscado));
  }

  useEffect(() => {
    dispatch(getCartillaPrestadores(idEfectorFact));
    dispatch(fetchEspecialidades(true));

    if (rubros?.length === 0) {
      dispatch(getRubrosEfector());
    }
    if (zonas?.length === 0) {
      dispatch(getZonasEfector());
    }
    if (centrosMedicos.length === 0) {
      dispatch(getCentrosMedicos());
    }
    if (rankingsCartilla.length === 0) {
      dispatch(getRankingsCartilla());
    }
    if (cartilla.length === 0) {
      dispatch(getCartilla());
    }
    if (planes.length === 0) {
      dispatch(getPlanes());
    }
    if (localidades.length === 0) {
      dispatch(fetchLocalidades());
    }
    if (provincias.length === 0) {
      dispatch(fetchProvincias());
    }
    // eslint-disable-next-line
  }, [dispatch]);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleChangeFile = (e) => {
    dispatch(SubirArchivoExcel(e.target.files[0]));
    e.target.value = null;
  };

  const downloadFile = () => {
    dispatch(DescargarPlantillaExcel());
  };

  if (prestadores === null)
    return <LoadingBeforeViewData />
  
  return (
    <>
      {!disabled && (
        <Grid container spacing={1} justify='flex-end' alignItems="center" className={classes.buttonContainer}>  
            {selectedIndex === 1 && (
            <Grid item md={4}  style={{ marginRight: "10rem" }}>
              <BuscadorAbm title="Buscar Profesional" handleSearch={handleSearch} placeholder = "Nombre y Apellido | CUIT"/>
            </Grid>
            )}
            {
            (dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS)
            &&
            <Grid item >
              <ButtonGroup
                variant="contained"
                color="inherit"
                ref={anchorRef}
                aria-label="split button"
              >
                {selectedIndex === 0 && (
                  <>
                    <input
                      accept="*/*"
                      className={classes.input}
                      style={{ display: "none" }}
                      id="selectArchivoExcel"
                      multiple
                      type="file"
                      onChange={handleChangeFile}
                    />
                    <Button
                      component="span"
                      variant="contained"
                      color="primary"
                      startIcon={<CloudUploadIcon />}
                      style={{ borderRadius: "3px 0px 0px 3px" }}
                      onClick={() =>
                        document.querySelector(`#selectArchivoExcel`).click()
                      }
                    >
                      Subir Plantilla
                    </Button>
                  </>
                )}
                {selectedIndex === 1 && (
                  
                  <Button
                    component="span"
                    variant="contained"
                    color="primary"
                    style={{ borderRadius: "3px 0px 0px 3px" }}
                    startIcon={<CloudDownloadIcon />}
                    onClick={downloadFile}
                  >
                    Descargar Plantilla{" "}
                  </Button>
                )}
                <Button
                  color="primary"
                  size="small"
                  aria-controls={open ? "split-button-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle}
                >
                  <ArrowDropDownIcon />
                </Button>
              </ButtonGroup>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                style={{ zIndex: 1 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top " : "center bottom",
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu">
                          <MenuItem
                            selected={0 === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, 0)}
                          >
                            Subir Plantilla
                          </MenuItem>
                          <MenuItem
                            selected={1 === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, 1)}
                          >
                            Descargar Plantilla
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </Grid>
          }
          {
            // (
              // (dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS)
              // ||
              // (prestadores.length === 0)
            // )
            // && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  // size="small"
                  onClick={handleOpenModal}
                // style={{ float: "right" }}
                >
                  + Agregar Prestador
                </Button>
              </Grid>
            // )
          }
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpenModalDeleteAll(true)}
            >
              Eliminar todos
            </Button>
            <Dialog open={openModalDeleteAll} onClose={() => setOpenModalDeleteAll(false)}>
              <DialogTitle>Eliminar todos</DialogTitle>
              <DialogContent><DialogContentText>{"¿Estás seguro que deseas eliminar todos los prestadores?"}</DialogContentText></DialogContent>
              <DialogActions>
                <Button color='secondary' onClick={() => setOpenModalDeleteAll(false)}>Cancelar</Button>
                <Button color='primary' onClick={() => {
                  dispatch(contratacionesPrestadoresDeleteAll())
                  setOpenModalDeleteAll(false)
                }}>Continuar</Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
      )}
      <PrestadoresTable
        disabled={disabled}
      />
      {
        openModal && (
          <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Agregar Prestador"}
            </DialogTitle>
            <DialogContent>
              <PrestadoresForm formData={null} handleSubmit={(data) => {
                dispatch(contratacionesPrestadorSave(data))
                handleCloseModal()
              }} handleCloseModal={handleCloseModal} />
            </DialogContent>
          </Dialog>
        )
      }

    </>
  );
});
